<div class="module-placeholder-host">
	<div class="post-list fallback-view">
		<div class="d-flex flex-row flex-wrap grid">
			<div *ngFor="let item of emptyItemList; let i = index" class="grid-item">
				<a class="post-image-container">
					<img class="post-img" [src]="'assets/images/No_Image.png'" alt="No image" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" />
				</a>
			</div>
		</div>
	</div>
	<div class="fade-out-content"></div>
	
	<div class="buttons text-center">
		<button class="button blue show-more-btn">{{ 'INFLUENCER.overview.show_more' | translate }}</button>
	</div>

	<influencer-module-placeholder *ngIf="hasNoData || isFetchingData" class="module-placeholder-container" [width]="361" 
		[isFetchingData]="isFetchingData" [hasNoData]="hasNoData">
	</influencer-module-placeholder>
</div>




// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/influencer-posts/influencer-posts-placeholder/influencer-posts-placeholder.component.html